module.exports = "/_next/static/images/fr-80949ae91a7844d275bce08b1b321cbe.svg";